import SVAvatar from '@pkgs/shared-client/components/SVAvatar';
import cn from '@pkgs/shared-client/helpers/cn';

const SVToasterThumbnails = ({
	thumbnails,
	logoURL,
	showAvatar,
	avatarURL,
}: {
	thumbnails?: Array<{ _id: string; image: { thumbnail: string } }> | string[];
	logoURL?: string;
	showAvatar?: boolean;
	avatarURL?: string;
}) => {
	if (!thumbnails && !logoURL) return null;

	const getThumbnailUrl = (
		thumbnail?: string | { _id: string; image: { thumbnail: string } },
	) => {
		if (!thumbnail) return '';
		if (typeof thumbnail === 'string') return thumbnail;
		return thumbnail.image?.thumbnail || '';
	};

	return (
		<div
			className={cn(
				'relative h-10 rounded-lg',
				showAvatar && avatarURL && 'ml-3',
				logoURL ? 'w-12' : 'w-10',
			)}
		>
			{showAvatar && avatarURL && thumbnails && (
				<div className="border-primary absolute -left-3 -top-0.5 z-10 rounded-full border-2">
					<SVAvatar className="h-6 w-6" src={avatarURL || ''} />
				</div>
			)}

			{showAvatar && avatarURL && !thumbnails && (
				<div className="flex h-full w-full flex-col items-stretch overflow-hidden">
					<SVAvatar className="h-6 w-6" src={avatarURL || ''} />
				</div>
			)}

			{logoURL ? (
				<img
					src={logoURL}
					alt="Team logo"
					className="h-full w-full rounded-lg object-contain"
				/>
			) : (
				<div className="absolute flex h-full w-full flex-col items-stretch space-y-0.5 overflow-hidden rounded-lg bg-gray-800 bg-opacity-50">
					{(thumbnails?.length || 0) > 0 ? (
						<div
							className="flex-1 basis-1/2 bg-gray-800 bg-cover bg-center bg-no-repeat"
							style={{
								backgroundImage: `url('${getThumbnailUrl(thumbnails?.[0])}')`,
							}}
						/>
					) : null}
					{(thumbnails?.length || 0) > 1 ? (
						<div className="flex basis-1/2 flex-row items-stretch space-x-0.5">
							<div
								className="flex-1 basis-1/2 bg-gray-800 bg-cover bg-center bg-no-repeat"
								style={{
									backgroundImage: `url('${getThumbnailUrl(thumbnails?.[1])}')`,
								}}
							/>
							{(thumbnails?.length || 0) > 2 ? (
								<div
									className="flex-1 basis-1/2 bg-gray-800 bg-cover bg-center bg-no-repeat"
									style={{
										backgroundImage: `url('${getThumbnailUrl(
											thumbnails?.[2],
										)}')`,
									}}
								/>
							) : null}
						</div>
					) : null}
				</div>
			)}
		</div>
	);
};

export default SVToasterThumbnails;
